// ======================================================================
// File Name       : UploadConfigFileContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

// ======================================================================
// File Name       : UploadConfigFileContainer
//
// Copyright(C) 2018 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React, { Component } from 'react';
import { Field, reduxForm, isInvalid, getFormValues } from 'redux-form';
import { connect } from 'react-redux';
import { Button, Form } from 'react-bootstrap';
import UploadConfigFileImport from '../../components/configFile/UploadConfigFileImport';
import UploadConfigFileList from '../../components/configFile/UploadConfigFileList';
import DialogConfirm from '../../components/DialogConfirm';
import { RETURN_MAX_NUM } from '../../constants/index';
import * as MessageTemplate from '../../constants/MessageTemplate';
import * as configFileAction from '../../actions/ConfigFileAction';
import Header from '../../components/Header';
import { handleDownload } from '../../utils/index';

class UploadConfigFileContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
    };
    this.onUploadCancel = this.onUploadCancel.bind(this);
    this.onUploadOk = this.onUploadOk.bind(this);
    this.searchData = this.searchData.bind(this);
    this.handleSortState = this.handleSortState.bind(this);
    this.refreshData = this.refreshData.bind(this);
    this.getStartEndData = this.getStartEndData.bind(this);
    this.onClickDownloadFile = this.onClickDownloadFile.bind(this);
    this.onClickUpload = this.onClickUpload.bind(this);
  }

  componentWillMount() {
    this.searchData();
  }

  componentWillUnmount() {
    const { dispatch } = this.props;
    dispatch(configFileAction.resetDataUploadConfigFile());
  }

  searchData(startPosition, column) {
    const { dispatch } = this.props;
    const defaultParam = {
      startPosition: 0,
      returnMaxNum: RETURN_MAX_NUM,
    };
    if (startPosition) {
      defaultParam.startPosition = startPosition;
    }
    if (column && Object.keys(column).length) {
      defaultParam.ascendingDescendingSort = column.sortState;
      defaultParam.userfrontDownloadSortType = column.sortBy;
    }

    if (!column) {
      defaultParam.ascendingDescendingSort = null;
      defaultParam.userfrontDownloadSortType = null;
    }
    dispatch(configFileAction.getUploadConfigFileResult(defaultParam));
  }

  onClickUpload() {
    const { formValues, invalid } = this.props;
    if (!formValues || !formValues.uploadFile || !formValues.uploadFile.length) {
      return;
    }
    if (invalid) {
      return;
    }
    this.setState({
      showModal: true,
    });
  }

  onUploadCancel() {
    this.setState({ showModal: false });
  }

  onUploadOk() {
    const { formValues, dispatch } = this.props;
    let uploadFile = null;
    if (formValues && formValues.uploadFile && formValues.uploadFile[0]) {
      uploadFile = formValues.uploadFile[0];
    }
    dispatch(configFileAction.uploadConfigFile(uploadFile)).then(() => {
      this.searchData();
    });
    this.setState({ showModal: false });
  }

  refreshData() {
    this.searchData();
  }

  handleSortState(column) {
    const { invalid, formValues } = this.props;
    if (invalid) return;
    let startPosition = 0;
    if (formValues && formValues.startPosition) {
      startPosition = formValues.startPosition;
    }
    this.searchData(startPosition, column);
  }

  getStartEndData(startPosition) {
    const { invalid, formValues } = this.props;
    if (invalid) return;
    let column = null;
    if (formValues && formValues.userfrontUploadSortType) {
      column = formValues.userfrontUploadSortType;
    }
    this.searchData(startPosition, column);
  }

  onClickDownloadFile(url, fileName) {
    return handleDownload(url, fileName);
  }

  render() {
    const { formValues, uploadConfigFile, invalid } = this.props;
    let disabled = false;
    let fileName = '';
    let fileSize = 0;
    if (!formValues || !formValues.uploadFile || !formValues.uploadFile.length) {
      disabled = true;
    } else {
      fileName = formValues.uploadFile[0].name;
      fileSize = formValues.uploadFile[0].size;
    }
    const { userfrontUploadResultList, recordNum } = uploadConfigFile;
    let startPosition = 0;
    if (formValues && formValues.startPosition) {
      startPosition = formValues.startPosition;
    }
    return (
      <div>
        <Header name="画面用構成ファイルアップロード" />
        <h3>アップロードする画面用構成ファイルを指定してください</h3>
        <Form
          onSubmit={(event) => {
            event.preventDefault();
            this.onClickUpload();
          }}
          className='form-horizontal'
        >
          <UploadConfigFileImport
            disabled={disabled}
            fileName={fileName}
            fileSize={fileSize}
          />
          <UploadConfigFileList
            userfrontUploadResultList={userfrontUploadResultList}
            recordNum={recordNum}
            invalid={invalid}
            getStartEndData={this.getStartEndData}
            onClickDownloadFile={this.onClickDownloadFile}
            handleSortState={this.handleSortState}
            refreshData={this.refreshData}
            startPosition={startPosition}
          />
        </Form>
        <DialogConfirm
          showModal={this.state.showModal}
          onCancel={this.onUploadCancel}
          content={MessageTemplate.BULK_UPLOAD}
          onOK={this.onUploadOk}
        />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { configFile } = state;
  const { uploadConfigFile } = configFile;
  return {
    formValues: getFormValues('uploadConfigFile')(state),
    invalid: isInvalid('uploadConfigFile')(state),
    uploadConfigFile,
  };
};

export default connect(mapStateToProps)(reduxForm({
  form: 'uploadConfigFile', // a unique identifier for this form
  touchOnChange: true,
})(UploadConfigFileContainer));
